import baustein from "baustein";
import carouselMixin from "./mixins/carousel-mixin";

const componentName = "trending-products-carousel";

export default baustein.register(componentName, {
    componentName,
    mixins: [carouselMixin],
});
